import React, { ReactElement } from 'react';
import NavLink from '../../design-system/NavLink';
import Phone from '../../design-system/Phone';
import Mail from '../../design-system/Mail';
import Location from '../../design-system/Location';

const Footer: React.FC = (): ReactElement => (
  <div className="flex flex-col w-full bg-secondary text-light text-base sm:items-center">
    <div className="h-full max-w-3xl flex flex-col justify-between p-4 sm:w-full sm:flex-row sm:items-center ">
      <div className="flex flex-col mb-8 sm:mb-0">
        <NavLink
          to="prezentare"
          onClick={() => {
            window.scroll(0, 0);
          }}
        >
          Prezentare
        </NavLink>
        <NavLink
          to="cabinet"
          onClick={() => {
            window.scroll(0, 0);
          }}
        >
          Cabinet
        </NavLink>
        <NavLink
          to="servicii"
          onClick={() => {
            window.scroll(0, 0);
          }}
        >
          Servicii
        </NavLink>
        <NavLink
          to="blog"
          onClick={() => {
            window.scroll(0, 0);
          }}
        >
          Blog
        </NavLink>
        <NavLink
          to="contact"
          onClick={() => {
            window.scroll(0, 0);
          }}
        >
          Contact
        </NavLink>
      </div>
      <div>
        <p className="text-xl font-bold py-1">Cabinet Logopedic NovaLogo</p>
        <Phone />
        <Mail />
        <Location />
        <p>Ore de lucru: Luni - Vineri 10:00 - 16:00</p>
      </div>
    </div>
    <div className="flex text-sm pl-4 sm:!pl-0">
      <p className="text-light">
        <sup>©</sup> Copyright NovaLogo
      </p>
      <a
        href="https://echim.ioanacatalina.com"
        target="_blank"
        className="text-light-gray  ml-4"
        rel="noreferrer"
      >
        Design IoanaCatalinaE.
      </a>
    </div>
  </div>
);

export default Footer;
